import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  list ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`career/list`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`career/findById`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteById ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`career/deleteById`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  saveOrUpdate ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`career/saveOrUpdate`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updatePushStatus ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`career/updatePushStatus`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
